import { TextField } from '@refinedev/antd';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { ShowInfoGrid, ShowInfoItem } from '@/components/general/ShowInfo/ShowInfo';
import CompanyContact from '@/model/General/CompanyContact';

interface ReceptionShowContactInfoProps {
  companyContact?: CompanyContact;
}

const { Text } = Typography;
const ReceptionShowContactInfo = (props: ReceptionShowContactInfoProps) => {
  const { t } = useTranslation();
  const { companyContact } = props;

  return (
    <ShowInfoGrid>
      <ShowInfoItem label={t('Contacto para envío de presupuesto')}>
        {companyContact ? (
          <Flex vertical gap={4}>
            <Text type="secondary" strong>
              {t('Nombre')}: <TextField value={companyContact.name ?? '-'} />
            </Text>
            <Text type="secondary" strong>
              {t('Email')}: <TextField value={companyContact.email ?? '-'} />
            </Text>

            <Text type="secondary" strong>
              {t('Teléfono')}: <TextField value={companyContact.phone ?? '-'} />
            </Text>
          </Flex>
        ) : (
          <Text>
            {t('No registrado')}. {t('Enviar al responsable de servicio al cliente')}
          </Text>
        )}
      </ShowInfoItem>
    </ShowInfoGrid>
  );
};

export default ReceptionShowContactInfo;
